import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "m21.2 4.3-8.08-4a2.49 2.49 0 0 0-2.24 0l-8.08 4a2.52 2.52 0 0 0-1.39 2.24v10.91A2.52 2.52 0 0 0 2.8 19.7l8.08 4A2.4 2.4 0 0 0 12 24a2.56 2.56 0 0 0 1.12-.26l8.08-4a2.52 2.52 0 0 0 1.39-2.25V6.55A2.52 2.52 0 0 0 21.2 4.3"
    }, null, -1)
  ]));
}
const basicShapeHexagon = { render };
export {
  basicShapeHexagon as default,
  render
};
//# sourceMappingURL=basic-shape-hexagon.svg.js.map
